import { type SearchItemsTransformerProps } from '../../../product-router/product/result-provider/result-provider-types';
import { useShowAllResultsSection, useShowFilteredResultsSection } from '../sections';

/**
 * This transformer adds the advanced search section to postQueryItems
 */
export const AdvancedSearchTransformer = ({
	preQueryItems,
	postQueryItems,
	productState,
	children,
}: SearchItemsTransformerProps) => {
	const showAllResultsSection = useShowAllResultsSection();
	const showFilteredResultsSection = useShowFilteredResultsSection();

	const postQueryItemsWithAdvancedSearch = {
		size: postQueryItems.size,
		sections: [showAllResultsSection, showFilteredResultsSection, ...postQueryItems.sections],
	};

	return children({
		preQueryItems,
		postQueryItems: postQueryItemsWithAdvancedSearch,
		productState,
	});
};
